import type { SavePaymentMethod } from "../types/Types";

/** Rows that represent a reusable Stripe card (excludes customer-only stub rows). */
export function getSavedCards(
  methods: SavePaymentMethod[] | undefined,
): SavePaymentMethod[] {
  return (methods ?? []).filter((m) => Boolean(m.paymentMethodId && m.last4));
}

export function getPrimarySavedCard(
  methods: SavePaymentMethod[] | undefined,
): SavePaymentMethod | undefined {
  return getSavedCards(methods)[0];
}
